export const commonButtonProps = (isPending: boolean) => ({
  small: true,
  wide: true,
  noMinWidth: true,
  disabled: isPending,
});
